import { render } from "./Estimation.vue?vue&type=template&id=470477d9"
import script from "./Estimation.vue?vue&type=script&lang=js"
export * from "./Estimation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__